// extracted by mini-css-extract-plugin
module.exports = {"sectionPill":"style-module__sectionPill___1-h-_","active":"style-module__active___zGjx7"};